import { FORECAST_STATUS, FORECAST_WINDOW_STATUS } from "@/components/forecasts/constants";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import { moment } from "@/utils/moment";
import session from "@/services/session";

export default class ForecastWindowValidator {
    static canSave(forecastWindow, accessUserPlugin) {

        // Forecast ne doit pas être supprimé
        if (forecastWindow.forecast.deleted === true) {
            return false;
        }

        // Forecast doit être ACTIF (sauf si mod dieu)
        if (forecastWindow.forecast.status !== FORECAST_STATUS.ACTIVE && !this.isGod()) {
            return false;
        }

        // Ne pas être DRAFT en godmod sans être superAdmin
        if (forecastWindow.forecast.status === FORECAST_STATUS.DRAFT && this.isGod() && !accessUserPlugin.isSuperAdmin()) {
            return false;
        }

        // Ne pas être ZONE_READER, doit être ZONE_FORECASTER
        if (accessUserPlugin.hasAccessByProfile(PROFILES.ZONE_READER) && !accessUserPlugin.hasAccessByProfile(PROFILES.ZONE_FORECASTER)) {
            return false;
        }

        if (accessUserPlugin.hasAccessByProfile(PROFILES.ZONE_FORECASTER)) {
            if (forecastWindow.multiValidation) {
                let today = moment();
                let startDate = moment(forecastWindow.startDate);
                let endDate = moment(forecastWindow.endDate);
                if (this.isGod()) {
                    return !forecastWindow.isValidated;
                }
                if (!forecastWindow.startDate || startDate.format("YYYYMMDD") > today.format("YYYYMMDD")) {
                    return false;
                }
                if (!forecastWindow.endDate || endDate.format("YYYYMMDD") < today.format("YYYYMMDD")) {
                    return false;
                }
            }
        }
        if (accessUserPlugin.hasAccessByProfile(PROFILES.FORECAST_MANAGER)) {
            if (this.isGod()) {
                return !forecastWindow.forecast.isTransmissionApproved;
            }
            return false;
        }

        return (
            forecastWindow.status === FORECAST_WINDOW_STATUS.DRAFT ||
            forecastWindow.status === FORECAST_WINDOW_STATUS.SAVED ||
            forecastWindow.status === FORECAST_WINDOW_STATUS.RE_CHALLENGED
        );
    }

    static zoneReaderCanDownloadXls(forecastWindow, accessUserPlugin) {
        if (forecastWindow.forecast.deleted === true) {
            return false;
        }
        if (forecastWindow.forecast.status !== FORECAST_STATUS.ACTIVE && !this.isGod()) {
            return false;
        }

        if (accessUserPlugin.hasAccessByProfile(PROFILES.ZONE_READER)) {
            return true;
        }

        return false;
    }

    static canSubmit(forecastWindow, accessUserPlugin) {
        if (forecastWindow.forecast.deleted === true) {
            return false;
        }
        if (forecastWindow.forecast.status !== FORECAST_STATUS.ACTIVE && !this.isGod()) {
            return false;
        }

        if (forecastWindow.forecast.status === FORECAST_STATUS.DRAFT && this.isGod() && !accessUserPlugin.isSuperAdmin()) {
            return false;
        }

        if (accessUserPlugin.hasAccessByProfile(PROFILES.ZONE_READER) && !accessUserPlugin.hasAccessByProfile(PROFILES.ZONE_FORECASTER)) {
            return false;
        }

        if (accessUserPlugin.hasAccessByProfile(PROFILES.ZONE_FORECASTER)) {
            return this.canSave(forecastWindow, accessUserPlugin);
        }

        if (accessUserPlugin.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR)) {
            if (this.isGod()) {
                return !forecastWindow.isValidated;
            }
            return forecastWindow.status !== FORECAST_WINDOW_STATUS.SUBMITTED;
        }

        if (accessUserPlugin.hasAccessByProfile(PROFILES.FORECAST_MANAGER)) {
            if (this.isGod()) {
                return !forecastWindow.forecast.isTransmissionApproved;
            } else {
                return forecastWindow.status !== FORECAST_WINDOW_STATUS.SUBMITTED;
            }
        }
        return !!accessUserPlugin.isSuperAdmin;
    }

    static hasForecastWindowsOpen(forecastWindows) {
        const hasFw = forecastWindows.filter(fw => {
            const endDate = moment(fw.endDate);
            const today = moment();
            return endDate.format("YYYYMMDD") >= today.format("YYYYMMDD");
        }).length;
        return hasFw > 0;
    }

    static isGod() {
        const isGod = JSON.parse(session.getValueSession("godMode"));
        return isGod != null ? isGod : false;
    }
}



// WEBPACK FOOTER //
// ./src/components/forecasts/validation/forecastWindowValidator.js